import { Fragment, useContext } from 'react';
import { match } from 'ts-pattern';

import useAnimatedDialogModals from '~/domains/common/context/useAnimatedDialogModals';
import DialogContainer from '~/domains/design-system/components/Dialog/DialogContainer';

import { ContestManageModalsContext } from './ContestManageModalsContext';
import CollectEntryFeesInfoModal from './types/CollectEntryFeesInfoModal/CollectEntryFeesInfoModal';
import RewardsProgramModal from './types/RewardsProgramModal/RewardsProgramModal';
import SelfManageInfoModal from './types/SelfManageInfoModal/SelfManageInfoModal';
import IntroModal from './types/IntroModal/IntroModal';
import GenericModal from './types/GenericModal/GenericModal';
import PricingInfoModal from './types/PricingInfoModal/PricingInfoModal';

function ContestManageModals() {
  const { modals, closeModal, isCloseDisabled } = useContext(ContestManageModalsContext);
  const { modalsCache, activeModal, closingModal } = useAnimatedDialogModals({
    modals,
  });

  return (
    <DialogContainer
      isOpen={!!modals.length}
      onClose={isCloseDisabled ? undefined : closeModal}
      lockScroll
    >
      {modalsCache.map((modal) => {
        const commonProps = {
          onClose: closeModal,
          isCloseDisabled,
          isOpen: activeModal === modal,
          isClosing: closingModal === modal,
        };

        return (
          <Fragment key={modal.type}>
            {match(modal)
              .returnType<React.ReactNode>()
              .with({ type: 'CollectEntryFeesInfoModal' }, (rest) => (
                <CollectEntryFeesInfoModal {...rest} {...commonProps} />
              ))
              .with({ type: 'RewardsProgramModal' }, (rest) => (
                <RewardsProgramModal {...rest} {...commonProps} />
              ))
              .with({ type: 'SelfManageInfoModal' }, (rest) => (
                <SelfManageInfoModal {...rest} {...commonProps} />
              ))
              .with({ type: 'IntroModal' }, (rest) => <IntroModal {...rest} {...commonProps} />)
              .with({ type: 'GenericModal' }, (rest) => <GenericModal {...rest} {...commonProps} />)
              .with({ type: 'PricingInfoModal' }, (rest) => (
                <PricingInfoModal {...rest} {...commonProps} />
              ))
              .otherwise(() => null)}
          </Fragment>
        );
      })}
    </DialogContainer>
  );
}

export default ContestManageModals;
